import { z } from 'zod';
import { Property } from './property.js';
import { RoleSchema } from './auth.js';

export type CreateUserRequest = {
  authProviderId: string;
};

export type GetUserDataResponse = {
  userId: string;
  properties: Property[];
};

export const OrgUserSchema = z.object({
  id: z.string(),
  name: z.string().nullable(),
  email: z.string(),
  profilePictureUrl: z.string().nullable().optional(),
});

export type OrgUser = z.infer<typeof OrgUserSchema>;

export const OrgUserWithRoleSchema = OrgUserSchema.extend({
  role: RoleSchema,
});
export type OrgUserWithRole = z.infer<typeof OrgUserWithRoleSchema>;

export const ASSIGNABLE_ROLES = ['user', 'agent', 'reviewer'] as const;
export const AssignableRoleSchema = z.enum(ASSIGNABLE_ROLES);
export type AssignableRole = z.infer<typeof AssignableRoleSchema>;

/** Org members who work cases (as opposed to plain property-owning `user`s). */
export const STAFF_ROLES = ['admin', 'reviewer', 'agent'] as const;
export const StaffRoleSchema = z.enum(STAFF_ROLES);
export type StaffRole = z.infer<typeof StaffRoleSchema>;

export const UpdateUserRoleRequestSchema = z.object({
  role: AssignableRoleSchema,
});
export type UpdateUserRoleRequest = z.infer<typeof UpdateUserRoleRequestSchema>;
